function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-4-4h24v24H-4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#898B91",
  d: "M8 0a8.009 8.009 0 018 8 8 8 0 11-8-8zm2.933 6.667H9.267a.167.167 0 01-.139-.26l1.31-1.964a.5.5 0 00-.416-.776H7.539a.667.667 0 00-.596.368L4.82 8.278A.5.5 0 005.267 9h1.04a.167.167 0 01.158.22L5.35 12.56a.333.333 0 00.553.342l5.382-5.383a.5.5 0 00-.352-.853z"
}));

function SvgUgcPersuasion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
}

export default SvgUgcPersuasion;